import React from 'react';
import { Stack, SvgIconProps } from '@mui/material';
import { SizingMultiplier, Typography } from '@ocx/ui';

export type OfferAvailabilityLabelProps = {
  icon: React.ComponentType<SvgIconProps>;
  children: React.ReactNode;
};

const ICON_SIZE = 12;
const BORDER_RADIUS = 1.5;

export const OfferAvailabilityLabel = ({ icon: IconComponent, children }: OfferAvailabilityLabelProps) => {
  return (
    <Stack
      direction="row"
      spacing={SizingMultiplier.xs / 2}
      sx={{
        alignItems: 'center',
        px: SizingMultiplier.sm,
        py: SizingMultiplier.xs,
        backgroundColor: (theme) => theme.palette.action.selected,
        borderRadius: BORDER_RADIUS,
      }}>
      <IconComponent sx={{ width: ICON_SIZE, height: ICON_SIZE, color: 'text.disabled' }} />
      <Typography variant="caption" component="span" color="text.secondary">
        {children}
      </Typography>
    </Stack>
  );
};
